<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-contextMenu #cm [model]="menuContextuel"></p-contextMenu>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <p-table #dt [value]="roles" dataKey="roleId" tableStyleClass="tableNormale" autoLayout="true"
                 [(contextMenuSelection)]="selectionRole"
                [contextMenu]="cm" [rowHover]="true" [rows]="25" [paginator]="true" [filterDelay]="0"
                [globalFilterFields]="['nom']">
                <ng-template pTemplate="caption">
                    <div class="flex align-content-center justify-content-between">
                        <div class="flex align-items-center gap-2">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Recherche..." />
                            </span>
                            <p-button icon="pi pi-plus"
                                severity="success"
                                (click)="ajouterRole()" 
                                pTooltip="Ajouter un rôle"
                                tooltipPosition="top"></p-button>
                        </div>
                        <h5 class="titreTableau m-0">Gestion des rôles</h5>
                        <div></div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nom">
                            <div class="flex justify-content-between align-items-center">
                                Nom du rôle
                                <p-sortIcon field="nom"></p-sortIcon>
                                <p-columnFilter type="text" field="nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nbTaches">
                            <div class="flex justify-content-between align-items-center">
                                Nombre de tâches
                                <p-sortIcon field="nbTaches"></p-sortIcon>
                                <p-columnFilter type="numeric" field="nbTaches" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nbEmployes">
                            <div class="flex justify-content-between align-items-center">
                                Nombre d'employés
                                <p-sortIcon field="nbEmployes"></p-sortIcon>
                                <p-columnFilter type="numeric" field="nbEmployes" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th style="min-width: 8rem; width: 8rem;">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-role>
                    <tr [pContextMenuRow]="role">
                        <td>
                            <div class="flex align-items-center">
                                <i class="pi pi-users mr-2" style="color: #1976D2;"></i>
                                <span [class.font-bold]="role.nom === 'SIHC_Administrateur'">{{role.nom}}</span>
                                <p-tag *ngIf="role.nom === 'SIHC_Administrateur'" 
                                       value="Système" 
                                       severity="info" 
                                       class="ml-2"></p-tag>
                            </div>
                        </td>
                        <td>
                            <p-tag [value]="role.nbTaches || 0" 
                                   [severity]="(role.nbTaches || 0) > 0 ? 'success' : 'warning'"></p-tag>
                        </td>
                        <td>
                            <p-tag [value]="role.nbEmployes || 0" 
                                   [severity]="(role.nbEmployes || 0) > 0 ? 'info' : 'secondary'"></p-tag>
                        </td>
                        <td>
                            <div class="flex gap-2">
                                <button pButton pRipple icon="pi pi-pencil" 
                                        class="p-button-success mr-1 boutonGrille"
                                        (click)="ouvrirDetail(role)"
                                        pTooltip="Modifier le rôle"
                                        tooltipPosition="top"></button>
                                <button pButton pRipple icon="pi pi-trash" 
                                        class="p-button-danger boutonGrille"
                                        (click)="confirmerSuppression(role)"
                                        [disabled]="role.nom === 'SIHC_Administrateur'"
                                        pTooltip="Supprimer le rôle"
                                        tooltipPosition="top"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" class="text-center">Aucun rôle trouvé.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>
